import Vue from 'vue';
import Router from 'vue-router';
import Home from '../Home.vue';
import UserProfile from '../UserProfile.vue'; // 确保路径正确

Vue.use(Router)

export default new Router({
  // mode: 'hash',
  // base: './dist/', // 加上这一行
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
      {
        path: '/user-profile',
        name: 'UserProfile',
        component: UserProfile,
        props: true
      }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js